import {
  Row,
  Col,
  Tooltip,
  DatePicker,
  Collapse,
  Space,
  Form,
  Input,
} from "antd";
import { MonedaSelect } from "../reusable/MonedaSelect";
import { CotizacionFormDetalle } from "./CotizacionFormDetalle";
import { VendedorSelect } from "../reusable/VendedorSelect";
import { DateFormats, MonedaConstants } from "../../../types/typesConstants";
import { FormItemHiddenUi } from "../../ui/FormItemHiddenUi";
import { Card, CloseBtn, SaveBtn } from "../../ui";
import { ClienteRow } from "./ClienteRow";
import { PhoneOutlined } from "@ant-design/icons";
const { TextArea } = Input;

const PanelInformacionAdicional = () => (
  <>
    <Row gutter={{ xs: 8, sm: 12, md: 16, lg: 24 }}>
      <Col xs={24} sm={24} md={24} lg={12} xl={8}>
        <Form.Item name="contacto">
          <Input placeholder="Ingrese nombre contacto" />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={24} lg={6} xl={4}>
        <Form.Item name="telefono">
          <Input
            placeholder="Ingrese telefono / movil"
            addonAfter={<PhoneOutlined />}
          />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={{ xs: 8, sm: 12, md: 16, lg: 24 }}>
      <Col xs={24} sm={24} md={24} lg={12} xl={8}>
        <Form.Item name="inforeference">
          <Input placeholder="Información referencial" />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={24} lg={12} xl={12}>
        <Form.Item name="observacion">
          <TextArea
            placeholder="Ingrese observación"
            rows={2}
            maxLength={1000}
            showCount
          />
        </Form.Item>
      </Col>
    </Row>
  </>
);
const itemsCollapse = [
  {
    key: "1",
    label: "Información adicional - (Opcional)",
    children: <PanelInformacionAdicional />,
  },
];
export const CotizacionForm = ({ handleCloseForm }) => {
  const form = Form.useFormInstance();
  const handleChangeMoneda = (e, field) => {
    const monedaprefijosunat = field?.prefijosunat;
    if (monedaprefijosunat === MonedaConstants.PEN) {
      form.setFieldsValue({ tipocambio: 1 });
    }
    form.setFieldsValue({
      monedaprefijo: field?.prefijo,
      monedaprefijosunat: field?.prefijosunat,
    });
  };
  return (
    <>
      <Card
        title="Cotización"
        size="small"
        extra={
          <Space wrap>
            <Tooltip title="Salir">
              <CloseBtn key="cerrar" onClick={handleCloseForm} />
            </Tooltip>
            <SaveBtn key="guardar" htmlType="submit" />
          </Space>
        }
      >
        <FormItemHiddenUi name="id" />
        <FormItemHiddenUi name="montosubtotal" />
        <FormItemHiddenUi name="montoigvtotal" />
        <FormItemHiddenUi name="montototal" />
        <FormItemHiddenUi name="montototalgravadas" />
        <FormItemHiddenUi name="montototalexoneradas" />
        <FormItemHiddenUi name="montototalinafectas" />
        <FormItemHiddenUi name="monedaprefijo" />
        <FormItemHiddenUi name="monedaprefijosunat" />
        <FormItemHiddenUi name="cliente" />
        <ClienteRow />
        <Row gutter={{ xs: 8, sm: 12, md: 16, lg: 24 }}>
          <Col xs={24} sm={24} md={24} lg={12} xl={8} xxl={8}>
            <Form.Item
              name="vendedor"
              rules={[
                { required: true, message: "El vendedor es obligatorio" },
              ]}
            >
              <VendedorSelect placeholder="Seleccione vendedor" allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={6} xxl={4}>
            <Form.Item
              name="moneda"
              rules={[{ required: true, message: "La moneda es obligatoria" }]}
            >
              <MonedaSelect
                placeholder="Seleccione moneda"
                onChange={handleChangeMoneda}
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 12, md: 16, lg: 24 }}>
          <Col xs={24} sm={24} md={8} lg={8} xl={6}>
            <Form.Item name="fechaemision" label="Fecha emisión">
              <DatePicker format={DateFormats.frontend} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={6}>
            <Form.Item name="fechaentrega" label="Fecha entrega">
              <DatePicker format={DateFormats.frontend} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={6}>
            <Form.Item name="fechavalidez" label="Fecha Válidez">
              <DatePicker format={DateFormats.frontend} />
            </Form.Item>
          </Col>
        </Row>

        <Collapse accordion items={itemsCollapse}></Collapse>
        <CotizacionFormDetalle />
      </Card>
    </>
  );
};
